function getRandomInt(min, max) {
  return Math.floor(Math.random() * (max + 1 - min) + min);
}

function animateDots(dots) {
  let prev;

  const loop = () => {
    let index = getRandomInt(0, dots.length - 1);
    if (index === prev) {
      index = getRandomInt(0, dots.length - 1);
    }
    prev = index;

    dots[index].classList.add('flashed');
    setTimeout(() => dots[index].classList.remove('flashed'), 1200);

    setTimeout(() => window.requestAnimationFrame(loop), 600);
  };

  window.requestAnimationFrame(loop);
}

export default function setDecoration(className) {
  const structures = document.querySelectorAll(className);
  if (!structures || !structures.length) return;

  [...structures].forEach((structure) => {
    const dots = structure.querySelectorAll('svg path');
    if (!dots || !dots.length) return;

    animateDots(dots);
  });
}
